import { render } from "./my-assets.vue?vue&type=template&id=61f90928"
import script from "./my-assets.vue?vue&type=script&lang=js"
export * from "./my-assets.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__